import { useSelector } from 'react-redux';
import _ from 'lodash';
import {AppState} from '@redux';

export const useFormPage = (formId:string) =>
    useSelector((state: AppState) => state?.formPage?.data[formId] || {} )

export const useFormPageSubmission = (formId:string) => {
  const formPage = useFormPage(formId)
  return _.get(formPage, 'details.submission', {})
}
export const useFormPageRecord = (formId:string) => {
  const formPage = useFormPage(formId)
  return _.get(formPage, 'details.record', {})
}

export const useFormPageFields = (formId:string) => {
  const page = useFormPage(formId)
  return _.get(page, 'details.fields',[]);
};

export const useFormPageFieldConfig = (formId:string, id: string) => {
  const pageFields = useFormPageFields(formId)
  return _.find(pageFields, {id});

};
export const useAllFormData = () => useSelector((state: AppState) => {
  return state?.formData?.data
})
export const useFormData = (formId: string) => useSelector((state: AppState) => {
  const {root_code = '', form_code = '',data = {}, original = {}} = {...(state?.formData?.data[formId] || {}) }

  return {root_code, form_code, data,original}
} )


